module.exports = __webpack_public_path__ + "img/badge_color_ms-academic.8c512dde.svg";